<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.ioc_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="ioc_reason">
            <label class="weui-form-preview__label">{{customLabel.ioc_reason || "变更原因"}}</label>
            <em class="weui-form-preview__value">{{
              form.main.ioc_reason
            }}</em>
          </div>
        </custom-layout>
      </div>
      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"          
        >
          <div class="form-detail-preview_num">{{ item.iocd_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="iocd_inoutno">
              <label class="weui-form-preview__label">{{customLabel.iocd_inoutno || "入库单号"}}</label>
              <span class="weui-form-preview__value">{{
                item.iocd_inoutno
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="iocd_pdno">
              <label class="weui-form-preview__label">{{customLabel.iocd_pdno || "入库行号"}}</label>
              <span class="weui-form-preview__value">{{
                item.iocd_pdno
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="iocd_pdym">
              <label class="weui-form-preview__label">{{customLabel.iocd_pdym || "入库期间"}}</label>
              <span class="weui-form-preview__value">{{
                item.iocd_pdym
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_detail">
              <label class="weui-form-preview__label">{{customLabel.pr_detail || "物料名称"}}</label>
              <span class="weui-form-preview__value">{{
                item.pr_detail
              }}</span>
            </div>
            <div class="weui-form-preview__item" v-if="item.pr_orispeccode" slot="pr_orispeccode">
              <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "型号"}}</label>
              <span class="weui-form-preview__value">{{
                item.pr_orispeccode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="iocd_inqty">
              <label class="weui-form-preview__label">{{customLabel.iocd_inqty || "数量"}}</label>
              <span class="weui-form-preview__value">{{
                item.iocd_inqty
              }} {{ item.pr_unit }}</span>
            </div>
            <change-field
              slot="成本单价"
              label="成本单价"
              :old-value="item.iocd_price_old"
              :new-value="item.iocd_price_new"
            />
            <change-field
              slot="成本金额"
              label="成本金额"
              :old-value="item.iocd_total_old"
              :new-value="item.iocd_total_new"
            />
            <div class="weui-form-preview__item" slot="pr_code">
              <label class="weui-form-preview__label">{{customLabel.pr_code || "物料编号"}}</label>
              <span class="weui-form-preview__value">{{
                item.pr_code
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_brand">
              <label class="weui-form-preview__label">{{customLabel.pr_brand || "厂家/品牌"}}</label>
              <span class="weui-form-preview__value">{{
                item.pr_brand
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pr_spec">
              <label class="weui-form-preview__label">{{customLabel.pr_spec || "规格"}}</label>
              <span class="weui-form-preview__value">{{
                item.pr_spec
              }}</span>
            </div>
          </custom-layout>
        </div>
      </div>
    </div>
    <!-- <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/stock/in_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
        >反审</a
      >
    </div> -->
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import ChangeField from "@/components/field/ChangeField";
import form from "@/mixins/form.js";

export default {
  components: {
    CustomLayout,
    ChangeField
  },
  mixins: [form],
  data() {
    return {
      baseUrl: "/api/storage/prodiodetailchange",
      // codeField: "pi_inoutno",
      // statusField: "pi_statuscode",
      // caller: 'ProductInit',
      // xtype:'stock-productinit-formpanel'
    };
  }
}
</script>